module.exports = __webpack_public_path__ + "img/bank-svg.9bb73ffd.svg";